<template>
    <div class="m-ticket-item">
        <a href="http://www.xfz.cn/apply/conference/?code=pYTHCKmwD9" target="_blank" style="text-decoration:none;color: #fff;">
            <div class="type"> {{ data.type }} </div>
            <div class="price" :class="{'break-word': data.price == '￥399'}"> {{ data.price }}</div>
            <div class="content"> {{ data.info }} </div>
            <div class="buy"> 购票 </div>
        </a>
    </div>
</template>

<script>
export default{
   props:['data'] 
}
</script>

<style lang="scss">

.m-ticket-item{
    display: inline-block;
    width: 1.65rem;
    height: 1.95rem;
    margin-right: .1rem;
    margin-left: .1rem;
    margin-top: 0px;
    vertical-align: top;
    text-align: center;
    color: #fff;
    background:{
        image: url('../assets/m/ticket-bg.png');
        repeat: no-repeat;
        size: 100%;
    }
    .type{
        font-weight: bold;
        font-size: .2rem;
        text-decoration: underline;
        padding-top: .2rem;
    }
    .price{
        font-weight: bold;
        font-size: .16rem;
        color: #ffa700;
        padding-top: .02rem;
    }
    .break-word{
        text-decoration: line-through;
    }
    .content{
        font-size: .1rem;
        padding: .05rem .02rem;
        height: .65rem;
   }
    .buy{
        margin: 0 auto;
        margin-top: .08rem;
        font-size: .14rem;
        width: .5rem;
        background: #ffa700;
    }
    &:nth-child(3n) {
        margin-left: 1.02rem;
        margin-top: -0.35rem;
    }
}

</style>


// WEBPACK FOOTER //
// MobileTicketItem.vue?769d9c9d